import {Component, Input} from "@angular/core";
import {MD_SIDENAV_DIRECTIVES} from "@angular2-material/sidenav";

@Component({
  selector: "module-root",
  template: `
<md-sidenav-layout class="container">
  <md-sidenav mode="side" [opened]="true" class="sidenav">
    <h3 class="name">{{name}}</h3>  
    <a *ngFor="let route of routes" [routerLink]="[route.name]">{{route.name}}</a>
  </md-sidenav>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</md-sidenav-layout>
  `,
  styles: [
    require("./component.css").toString()
  ],
  directives: [MD_SIDENAV_DIRECTIVES]
})
export class ModuleRoot {
  @Input() routes: Array<{ name: string }>;
  @Input() name: string;

  constructor() {
    this.routes = [];
  }
}



/** WEBPACK FOOTER **
 ** ./script/shared/moduleroot/component.ts
 **/